export default __webpack_public_path__ + "static/media/artistPage1.87c51a7f.jpg";